export const INVENTORY_COUNTS_DEFAULT_TABLE_LIMIT = 20;
export const INVENTORY_COUNT_EMPTY_TABLE_VALUE = '-';
